<!-- <div class="file-selector">
    <input id="fileInput"
           type="file"
           #fileControl
           class="file-input"
           [attr.multiple]="isMultiple ? '' : null"
           accept="{{ fileTypes }}"
           [disabled]="isDisabled ? '' : null"
           (change)="onFileSelectionChanged($event)">
    <label for="fileInput"
           class="file-input-button mat-raised-button {{ buttonClass }}"
           [class.disabled]="isDisabled">
        {{ label }}
    </label>
</div> -->
<!-- MV3-3890 - File Control not working in IE -->
<label class="file-selector">
    <input id="fileInput" type="file" #fileControl class="file-input" [attr.multiple]="isMultiple ? '' : null"
        accept="{{ fileTypes }}" [disabled]="isDisabled ? '' : null" (change)="onFileSelectionChanged($event)">    
    <span for="fileInput" class="file-input-button mat-mdc-raised-button {{ buttonClass }}" [class.disabled]="isDisabled">
        {{ label }}
    </span>
</label>

<span class="image-required" *ngIf="!letterheadImage && isLetterHead"> {{ 'paperlessCommercialInvoice.dialog.settings.letterhead.required' | translate }} </span>
<span class="image-required" *ngIf="isLetterHead && showLetterHeadError"> {{ 'paperlessCommercialInvoice.dialog.settings.letterhead.fileSizeExceeded' | translate }} </span>

<span class="image-required" *ngIf="!signatureImage && isSignature"> {{ 'paperlessCommercialInvoice.dialog.settings.signature.required' | translate }} </span>
<span class="image-required" *ngIf="isSignature && showSignatureError"> {{ 'paperlessCommercialInvoice.dialog.settings.signature.fileSizeExceeded' | translate }} </span>
